angular
    .module('MyApp')
        .factory('AcordoFactory', function() {
            return {
                opcoesDoAcordo: {}
            }
        });